import AxiosCustom from "common/components/apiConfig";

export function insert_pishro_send_otp(payload) {
  let config = {
    url: "insert_request",
  };
  let data = {
    table: "clubmember",
    method_type: "pishro_send_otp",
    data: payload.data ? payload.data : {},
  };

  return AxiosCustom(config, data);
}
